<template>
  <v-dialog
    v-if="dialog"
    v-model="dialog"
    @click:outside="persistent ? escapeModal : null"
    @keydown.esc="persistent ? escapeModal : null"
    :width="width"
    :fullscreen="fullscreen"
    :persistent="persistent"
    scrollable
  >
    <v-card>
      <ModalTitle :title="title" :name="name" v-if="showHeader" />
      <v-card-text class="body-1 pt-5 pr-6 pl-6 pb-5">
        <slot name="body" />
      </v-card-text>
      <v-card-actions class="d-flex justify-end pb-5 pr-5" v-if="actions">
        <div class="text-right">
          <slot name="actions" />
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ModalTitle from './modal/ModalTitle'

import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'Modal',

  components: {
    ModalTitle,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
    title: {
      type: String,
    },
    actions: {
      type: Boolean,
      default: false,
    },
    width: {
      type: [String, Number],
      default: 500,
    },
    fullscreen: {
      type: Boolean,
      default: false,
      required: false,
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    showHeader: {
      required: false,
      default: true
    }
  },

  computed: {
    ...mapGetters(['activeModal']),

    dialog: {
      get() {
        this.$emit('modalOpened')
        return this.activeModal === this.name
      },
      set() {
        this.closeModal(this.activeModal)
      },
    },
  },

  methods: {
    ...mapActions(['closeModal']),
    ...mapMutations(['closeAllModals']),

    handleAction() {
      this.action()
    },

    close() {
      this.closeModal(this.name)
    },

    escapeModal() {
      this.closeAllModals()
    },
  },
}
</script>
